<template>
<div
    v-on:focusout="onFocusOut"
>
    <div
        v-if="parsed_value == null && is_default"
    >
        <div
            style="display: flex; gap: 15px;"
        >
            <div
                style="flex-grow: 1"
            >
                <div 
                    style="font-size: 18px; margin-bottom: 7px;">
                    <b>{{label}}</b>
                </div>

                <v-text-field
                    label="CSS"
                    value="No Default Value"
                    :readonly="is_default"
                    disabled
                />
            </div>
        </div>
    </div>

    <div
        v-if="parsed_value != null"
    >
        <div
            style="display: flex; gap: 15px;"
        >
            <div
                v-if="parsed_value.type == 'unknown'"
                style="flex-grow: 1"
            >
                <div 
                    style="font-size: 18px; margin-bottom: 7px;">
                    <b>{{label}}</b>
                </div>

                <v-text-field
                    label="CSS"
                    v-model="css"
                    :readonly="is_default"
                    :disabled="is_default"
                    v-on:input="onEdit"
                />
            </div>

            <div
                v-if="parsed_value.type == 'rgba'"
                style="flex-grow: 0px; min-width: 150px; height: 150px; position: relative; border: 1px solid rgba(0,0,0,0.3); justify-content: center;"
            >
                <div
                    class="checker"
                />

                <div
                    class="swatch"
                    :style="style_color_swatch"
                />
            </div>

            <div
                style="flex-grow: 1"
                v-if="parsed_value.type == 'rgba'"
            >
                <div 
                    style="font-size: 18px; margin-bottom: 7px;">
                    <b>{{label}}</b>
                </div>

                <div
                    style="display: flex; gap: 10px;"
                >
                    <v-text-field
                        label="Red"
                        v-model="parsed_value.red"
                        :readonly="is_default"
                        :disabled="is_default"
                        v-on:input="onEdit"
                    />

                    <v-text-field
                        label="Green"
                        v-model="parsed_value.green"
                        :readonly="is_default"
                        :disabled="is_default"
                        v-on:input="onEdit"
                    />

                    <v-text-field
                        label="Blue"
                        v-model="parsed_value.blue"
                        :readonly="is_default"
                        :disabled="is_default"
                        v-on:input="onEdit"
                    />

                    <v-text-field
                        label="Alpha"
                        v-model="parsed_value.alpha"
                        :readonly="is_default"
                        :disabled="is_default"
                        v-on:input="onEdit"
                    >
                        <span
                            slot="append-outer"
                            v-if="!is_default"
                        >
                            <v-menu 
                                bottom 
                                offset-y  
                            >
                            
                            <template v-slot:activator="{ on }">
                                    
                                <v-icon 
                                    v-on="on"
                                >
                                    mdi-dots-vertical
                                </v-icon>
                                    
                            </template>
                            
                            <v-list>
                                <v-list-item
                                    v-for="(item, index) in css_named_colors"
                                    :key="'named_color_'+index"
                                    v-on:click="onClickNamedColor(item)"
                                >
                                    <v-list-item-title>{{item.text}}</v-list-item-title>
                                </v-list-item>
                            
                            </v-list>
                            
                            </v-menu> 
                        </span>    
                    </v-text-field>
                </div>

                <v-text-field
                    label="CSS"
                    :value="css"
                    :readonly="true"
                    :disabled="true"
                />
                
            </div>

            <div
                v-if="parsed_value.type == 'dimensioned-value'"
                style="flex-grow: 1"
            >
                <div 
                    style="font-size: 18px; margin-bottom: 7px;">
                    <b>{{label}}</b>
                </div>

                <div
                    style="display: flex; gap: 10px;"
                >
                    <v-text-field
                        label="Magnitude"
                        v-model="parsed_value.magnitude"
                        :readonly="is_default"
                        :disabled="is_default"
                        v-on:input="onEdit"
                    />

                    <v-text-field
                        label="Unit"
                        v-model="parsed_value.unit"
                        :readonly="true"
                        :disabled="true"
                    />
                </div>

                <v-text-field
                    label="CSS"
                    :value="css"
                    :readonly="true"
                    :disabled="true"
                />
            </div>

            <div
                v-if="parsed_value.type == 'directional'"
                style="flex-grow: 1"
            >
                <div 
                    style="font-size: 18px; margin-bottom: 7px;">
                    <b>{{label}}</b>
                </div>

                <div
                    style="display: flex; gap: 30px;"
                >
                    <v-text-field
                        label="top"
                        v-model="parsed_value.top.magnitude"
                        :readonly="is_default"
                        :disabled="is_default"
                        v-on:input="onEdit"
                    >
                        <template #append>
                            {{parsed_value.top.unit}}
                        </template> 
                    </v-text-field>

                    <v-text-field
                        label="right"
                        v-model="parsed_value.right.magnitude"
                        :readonly="is_default"
                        :disabled="is_default"
                        v-on:input="onEdit"
                    >
                        <template #append>
                            {{parsed_value.right.unit}}
                        </template> 
                    </v-text-field>

                    <v-text-field
                        label="bottom"
                        v-model="parsed_value.bottom.magnitude"
                        :readonly="is_default"
                        :disabled="is_default"
                        v-on:input="onEdit"
                    >
                        <template #append>
                            {{parsed_value.bottom.unit}}
                        </template> 
                    </v-text-field>

                     <v-text-field
                        label="left"
                        v-model="parsed_value.left.magnitude"
                        :readonly="is_default"
                        :disabled="is_default"
                        v-on:input="onEdit"
                    >
                        <template #append>
                            {{parsed_value.left.unit}}
                        </template> 
                    </v-text-field>
                    
                </div>

                <v-text-field
                    label="CSS"
                    :value="css"
                    :readonly="true"
                    :disabled="true"
                />
            </div>

            <div
                v-if="parsed_value.type == 'font-stack'"
                style="flex-grow: 1"
            >
                <v-select
                    label="Font"
                    :items="font_families"
                    v-model="css"
                    :readonly="is_default"
                    :disabled="is_default"
                    v-on:change="onEdit"
                />

                <div
                    :style="style_demo_font"
                    class="font-demo"
                >
                    Lorem ipsum
                </div>
            </div>
            

        </div>
    </div>
</div>
</template>

<script>
const _ = require('lodash');

export default {
    props: {
        value: {
            type: String,
            default: function() { return null; }
        },

        is_default: {
            type: Boolean,
            default: function() { return false; }
        },

        property_name: {
            type: String,
            default: function() { return null; }
        },
    },

    data() {
        return {
            css: null,
            parsed_value: null,
            font_families: [],
            css_named_colors: [
                {'text': 'Black', 'value': 'rgba(0,0,0,1.0)'},
                {'text': 'White', 'value': 'rgba(255,255,255,1.0)'},

                {'text': 'Blue', 'value': 'rgba(0, 0, 255,1)'},
                {'text': 'Cyan (Aqua)', 'value': 'rgba(0, 255, 255,1)'},
                {'text': 'Gray', 'value': 'rgba(128, 128, 128 ,1)'},
                {'text': 'Green', 'value': 'rgba(0, 128, 0 ,1)'},
                {'text': 'Lime', 'value': 'rgba(0, 255, 0 ,1)'},
                {'text': 'Magenta (Fuchsia)', 'value': 'rgba(255, 0, 255 ,1)'},
                {'text': 'Maroon', 'value': 'rgba(128, 0, 0 ,1)'},
                {'text': 'Navy', 'value': 'rgba(0, 0, 128 ,1)'},
                {'text': 'Olive', 'value': 'rgba(128, 128, 0 ,1)'},
                {'text': 'Purple', 'value': 'rgba(128, 0, 128 ,1)'},
                {'text': 'Red', 'value': 'rgba(255, 0, 0 ,1)'},
                {'text': 'Silver', 'value': 'rgba(192, 192, 192 ,1)'},
                {'text': 'Teal', 'value': 'rgba(0, 128, 128 ,1)'},
                {'text': 'Yellow', 'value': 'rgba(255, 255, 0 ,1)'},
                
            ],
        }
    },

    created() {
        this.update();
    },

    methods: {
        update() {

            if ( this.value == null )
            {
                this.parsed_value = null;
                return;
            }

            this.$rc.rest({
                'spinner': false,
                'endpoint': 'PUT: /api/v1/css/parse',
            
                'params' : {
                        'css': this.value,
                        'property_name': this.property_name,
                    },
            
                'on_success': (data) => {
                        this.css = data.css;
                        this.parsed_value = data.parsed_value;

                        if ( this.parsed_value.type == 'font-stack' )
                            this.updateFontFamilies();
                    },
            
                'on_error': () => { this.parse = null; },
            });
        },

        updateFontFamilies()
        {
            if ( this.font_families.length > 0 )
                return;

            this.$rc.rest({
                'spinner': false,
                'endpoint': 'LIST: /api/v1/css/available-font-families',
            
                'params' : {
                        'organization_id': this.$route.params.organization_id,
                    },
            
                'on_success': (data) => {
                        this.font_families = data.results;
                    },
            
                'on_error': 'Unable to list font families',
            });
        },

        onFocusOut()
        {
            if ( !this.is_default )
                this.doEdit();
        },

        onEdit: _.debounce(function(){
            this.doEdit();
        }, 751),
        
        doEdit()
        {
            if ( this.parsed_value.type == 'font-stack' )
            {
                // Direct edit css types
                this.$emit('input',this.css);
                return;
            }

            if ( this.parsed_value.type == 'unknown' )
            {
                this.$emit('input', this.css);
                return;
            }

            this.$rc.rest({
                'spinner': false,
                'endpoint': 'PUT: /api/v1/css/compute',
            
                'params' : {
                        'parsed_value': this.parsed_value,
                    },
            
                'on_success': (data) => {
                        this.parsed_value = data.parsed_value;
                        this.css = data.css;
                        this.$emit('input',data.css);
                    },
            
                'on_error': () => {},
            });
        },
        

        onClickEdit()
        {
            this.$refs['edit-css-property-dialog'].showDialog();
        },

        onClickNamedColor(item)
        {
            this.$emit('input', item.value);
        },
    },

    computed: {
        style_color_swatch() {
            return 'background-color: '+this.css;
        },

        style_demo_font() {
            return 'font-size: 30px; font-family: '+this.css;
        },

        label() {
            return this.is_default ? 'Default Value' : 'Current Value'; 
        },
    },

    watch: {
        value(newValue, oldValue) {
            this.update();
        }
    },
}
</script>

<style lang="scss" scoped>
.checker
{
    position: absolute;
    top: 0;
    left: 0;

    width: 100%;
    height: 100%;
    
    background-image: url('https://files.redchirp.com/dcf69ef7-2e39-4bcd-b0ca-cd4be32eeff2.webp'); 
    background-size: cover; 
    background-position: center;
    background-repeat: no-repeat;

    z-index: 1;
}

.swatch
{
    position: absolute;
    top: 0;
    left: 0;

    width: 100%;
    height: 100%;

    z-index: 2;
}

.font-demo
{
    padding: 15px;
    margin-bottom: 10px;
    margin-top: 10px;
    text-align: center;
    border: 1px solid rgba(0,0,0,0.3);
}
</style>